import React, { useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import { useNavigate, useParams } from "react-router-dom";
import { BiCode, BiSupport, BiUser } from "react-icons/bi";
import { RiSecurePaymentLine } from "react-icons/ri";
import AISettingsModal from "../Codespaces/AI/SettingsModal.js/AISettingsModal";
import { TbTerminal } from "react-icons/tb";

function Settings() {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id } = useParams();
    const { t, changeLanguage, language } = useLanguage();
    const navigate = useNavigate()
    const [context, setContext] = useState(null)
    const [showModal, setShowModal] = useState(false)

    const getCodebase = async () => {
        try {
            const response = await fetch(
                "https://backend.erioon.com/get_codespace",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ user_id, project_id }),
                }
            );

            if (!response.ok) throw new Error("Failed to fetch codebase");

            const data = await response.json();
            setContext(data.context);

        } catch (error) {
            console.error("Error fetching codebase:", error);
        }
    };

    const OpenModal = () => {
        getCodebase()
        setShowModal(true)
    }

    return (
        <div className="main_view_section">
            <div className="settings">
                <div className="section_settings">

                    <p className="new_section_main_view_title fade-in">
                        Settings
                    </p>
                    <p className="main_view_subtitle fade-in">Personal settings</p>

                    <div className="link_app_container fade-in">

                        <div className="app_link" onClick={() => navigate("/control_panel/profile")}>
                            <i className=""><BiUser /></i>
                            <div className="link_app_desc">
                                <p className="title_link_app_desc">Profile</p>
                                <p className="desck_link_app">Personal info, password reset and more</p>
                            </div>
                        </div>
                        {/* <div className="app_link" onClick={OpenModal}>
                            <i className=""><TbTerminal /></i>
                            <div className="link_app_desc">
                                <p className="title_link_app_desc">Codespace settings</p>
                                <p className="desck_link_app">AI permissions and domains</p>
                            </div>
                        </div> */}
                        <div className="app_link" onClick={() => navigate("/control_panel/billing")}>
                            <i className=""><RiSecurePaymentLine /></i>
                            <div className="link_app_desc">
                                <p className="title_link_app_desc">Plans and payments</p>
                                <p className="desck_link_app">Active tiers, plans and payment informations</p>
                            </div>
                        </div>
                        <div className="app_link" onClick={() => navigate("/control_panel/support")}>
                            <i className=""><BiSupport /></i>
                            <div className="link_app_desc">
                                <p className="title_link_app_desc">Support</p>
                                <p className="desck_link_app">Tickets and support requests</p>
                            </div>
                        </div>
                        <div className="app_link" onClick={() => window.open("/dev-docs/introduction", "_blank")}>
                            <i className=""><BiCode /></i>
                            <div className="link_app_desc">
                                <p className="title_link_app_desc">Developers</p>
                                <p className="desck_link_app">Resources and documentation</p>
                            </div>
                        </div>
                    </div>


                </div>

            </div>
            <AISettingsModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                context={context}
            />
        </div>
    )
}

export default Settings